<div class="modal-header customBlueHeader" >
    <p class="modal-title">Delete Test</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
  <div class="modal-body customModalBody">
    <p>Are you sure, you want to delete this test?</p>

  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn green_btn" (click)="modelClose()">Cancel</button>

    <button type="button" class="btn green_btn" (click)="deleteItem()">Delete</button>
  </div>